//////////////////////////////////////////////////////////////////////////////////////////
//
// WhitemarkExt
// Applies inline style to a root div to declare colors to use -> ref in scss variables ground
// Props are only dom childrens
// Contrary to layout/Whitemark.jsx we targetting localStorage as token storage
//
//////////////////////////////////////////////////////////////////////////////////////////

import React from "react"
import PropTypes from "prop-types"

import { wmColor, firstValidColor } from "../../utils/whitemark"

const WhitemarkExt = (props) => {
	let w = localStorage.getItem("token")
		? JSON.parse(localStorage.getItem("token"))?.userSession?.userWhitemark
		: undefined
	let style

	if (w) {
		style = {
			// --ogOrange (the previous --ogOrange2 was consumed nowhere): the
			// extension surfaces read the same variables as the webapp.
			"--ogOrange": wmColor(w.colorIntern2, "#F47532"),
			"--ogBlack": wmColor(w.colorIntern3, "#181A3A"),
			"--ogBlue": wmColor(w.colorIntern1, "#39499B"),
			"--ogActionBlue": wmColor(w.colorIntern4, "#2833B7"),
			"--ogActionBlue2": wmColor(w.colorIntern4, "#2833B7"),
			// colorIntern6 is never written by the editor: the button color it
			// was meant to carry lives in bgColorClickButton.
			"--ogButton": wmColor(
				firstValidColor(w.colorIntern6, w.bgColorClickButton),
				"#F47532",
			),
		}
	} else {
		style = {
			"--ogOrange": "#F47532",
			"--ogBlack": "#181A3A",
			"--ogBlue": "#39499B",
			"--ogActionBlue": "#2833B7",
			"--ogActionBlue2": "#2833B7",
			"--ogButton": "#F47532",
		}
	}

	return <div style={style}>{props.children}</div>
}

export default WhitemarkExt

WhitemarkExt.propTypes = {
	children: PropTypes.node,
}
